export const Wines = () => {
   return <div className="wines">Wines coming soon</div>

   // Vintage
   // Varietal (grape)
   // Region/Appellation 
   // Alcohol content
   // Taste profile/ flavors
   // Aromas

}